"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var asyncReducer_1 = require("../utils/asyncReducer");

function useAsyncEffect(fn) {
  var args = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }

  var _a = asyncReducer_1.useAsyncReducer(),
      _b = _a[0],
      loading = _b.loading,
      data = _b.data,
      error = _b.error,
      _c = _a[1],
      setLoading = _c.setLoading,
      setData = _c.setData,
      setError = _c.setError;

  react_1.useEffect(function () {
    var unsub = false;
    setLoading();
    fn().then(function (data) {
      if (!unsub) {
        setData(data);
      }
    }).catch(function (e) {
      if (!unsub) {
        setError(e.message);
      }
    });
    return function () {
      unsub = true;
    };
  }, args);
  return {
    loading: loading,
    data: data,
    error: error
  };
}

exports.useAsyncEffect = useAsyncEffect;